
export const appRoot = () => document.getElementById("app-root");
export const windowRoot = () => document.getElementById("window-root");